import React from 'react';
import classNames from 'classnames';
import PropTypes, {bool, func, number, string} from 'prop-types';
import {Form} from "react-bootstrap";

import './Input.css';

const Input = ({
                  id,
                  style,
                  text,
                  inputType,
                  min,
                  name,
                  onPaste,
                  handleChange,
                  inputText,
                  inputTextValue,
                  disabled,
                  layout,
                  hasError,
                  handleOnBlur,
                  placeHolder,
                  showInfoButton,
               }) => {
   const auxLayout = layout === 'column' ? '' : '-row';

   return (
      <Form.Group>
         <Form.Label>{text}</Form.Label>
         <Form.Control type={inputType}
                       style={style}
                       min={min}
                       id={id}
                       className={classNames(
                          {error: hasError},
                          'input-background',
                       )}
                       name={name}
                       onChange={handleChange}
                       onPaste={onPaste}
                       onBlur={handleOnBlur}
                       placeholder={placeHolder}
                       defaultValue={inputText}
                       value={inputTextValue}
                       disabled={disabled}/>
      </Form.Group>
   );
};

Input.propTypes = {
   disabled: bool,
   hasError: bool,
   handleChange: func,
   handleOnBlur: func,
   onPaste: func,
   id: string,
   inputText: PropTypes.oneOfType([string, number]),
   inputTextValue: PropTypes.oneOfType([string, number]),
   inputType: string,
   layout: string,
   min: number,
   name: string.isRequired,
   text: string,
   showInfoButton: bool
};

Input.defaultProps = {
   disabled: false,
   hasError: false,
   handleChange: null,
   handleOnBlur: null,
   id: null,
   inputText: undefined,
   inputTextValue: undefined,
   inputType: 'text',
   layout: 'column',
   min: 0,
   text: '',
   showInfoButton: false
};

export default Input;
